import { useIntl } from 'react-intl';

import { Modal } from '~/eds/src/components/Modal/Modal';
import { Text } from '~/eds/src/components/Text/Text';

interface RetractFromSupplierPortalModalProps {
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
}

export const RetractFromSupplierPortalModal = ({
  onCancel,
  onConfirm,
  isLoading = false,
}: RetractFromSupplierPortalModalProps) => {
  const intl = useIntl();

  return (
    <Modal
      data-testid="retract-from-supplier-portal-modal"
      isVisible
      title={intl.formatMessage({
        id: 'TicketDocumentActions.retractFromSupplierPortalModalTitle',
        defaultMessage: 'Retract from Supplier Portal',
        description:
          'Title for retract from supplier portal confirmation modal',
      })}
      width="m"
      onCancel={onCancel}
      onHide={onCancel}
      primaryAction={{
        text: intl.formatMessage({
          id: 'TicketDocumentActions.retractButton',
          defaultMessage: 'Retract',
          description: 'Retract button text in confirmation modal',
        }),
        onClick: onConfirm,
        isLoading,
      }}
      cancelText={intl.formatMessage({
        id: 'TicketDocumentActions.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Cancel button text',
      })}
      enableContentPadding
    >
      <Text variant="body">
        {intl.formatMessage({
          id: 'TicketDocumentActions.retractFromSupplierPortalConfirm',
          defaultMessage:
            'Retracting this document will remove it from the Supplier Portal and the Supplier will no longer have access to this version. Are you sure you want to retract?',
          description:
            'Confirmation message for retract from supplier portal action',
        })}
      </Text>
    </Modal>
  );
};
